import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitGrowUpFarmsQuestionnaire } from "../../redux/actions/growUpFarmsActions";

const HealthAndSafetyQuestionnaire = ({ appData, submitQuestionnaire }) => {
  const initialData = {
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);
  const initialState = {
    whoIsResponsible: {
      key: "whoIsResponsible",
      title: "1. Who is responsible for H&S at GrowUp Farms?",
      value: getVal("whoIsResponsible"),
      mandatory: true,
    },
    ifUnclear: {
      key: "ifUnclear",
      title:
        "2. What should you do if you can't understand an instruction or if it is unclear?",
      value: getVal("ifUnclear"),
      mandatory: true,
    },
    blurb1: {
      htmlObj: <div>3. What are the 6 “Golden Rules” ?</div>,
    },
    goldenRule1: {
      key: "goldenRule1",
      title: "Rule 1",
      value: getVal("goldenRule1"),
      mandatory: true,
    },
    goldenRule2: {
      key: "goldenRule2",
      title: "Rule 2",
      value: getVal("goldenRule2"),
      mandatory: true,
    },
    goldenRule3: {
      key: "goldenRule3",
      title: "Rule 3",
      value: getVal("goldenRule3"),
      mandatory: true,
    },
    goldenRule4: {
      key: "goldenRule4",
      title: "Rule 4",
      value: getVal("goldenRule4"),
      mandatory: true,
    },
    goldenRule5: {
      key: "goldenRule5",
      title: "Rule 5",
      value: getVal("goldenRule5"),
      mandatory: true,
    },
    goldenRule6: {
      key: "goldenRule6",
      title: "Rule 6",
      value: getVal("goldenRule6"),
      mandatory: true,
    },
    fireAssembly: {
      key: "fireAssembly",
      title: "4. Where is/are the fire assembly points?",
      value: getVal("fireAssembly"),
      mandatory: true,
    },
    nearMiss: {
      key: "nearMiss",
      title: "5. Why should near misses be reported?",
      value: getVal("nearMiss"),
      mandatory: true,
    },
    plasters: {
      key: "plasters",
      title: "6. Who can issue plasters?",
      value: getVal("plasters"),
      mandatory: true,
    },
    signsColour: {
      key: "signsColour",
      title: "7. What is the colour for prohibition signs?",
      value: getVal("signsColour"),
      mandatory: true,
    },
    tidiness: {
      key: "tidiness",
      title: "8. How can tidiness help reduce accidents?",
      value: getVal("tidiness"),
      mandatory: true,
    },
    ppeInfo: {
      key: "ppeInfo",
      title: "9. Where can you find information regarding PPE requirements?",
      value: getVal("ppeInfo"),
      mandatory: true,
    },
    forkLift: {
      key: "forkLift",
      title: "10. Who is allowed to use forklift trucks?",
      value: getVal("forkLift"),
      mandatory: true,
    },
    scissorLift: {
      key: "scissorLift",
      title: "11. Who is allowed to use a scissor lift?",
      value: getVal("scissorLift"),
      mandatory: true,
    },
    stepLadder: {
      key: "stepLadder",
      title: "12. Who is allowed to use a step ladder?",
      value: getVal("stepLadder"),
      mandatory: true,
    },
    blurb2: {
      htmlObj: (
        <div>
          13. What should you check before plugging in an electrical appliance?
        </div>
      ),
    },
    checkBefore1: {
      key: "checkBefore1",
      title: "Check 1",
      value: getVal("checkBefore1"),
      mandatory: true,
    },
    checkBefore2: {
      key: "checkBefore2",
      title: "Check 2",
      value: getVal("checkBefore2"),
      mandatory: true,
    },
    checkBefore3: {
      key: "checkBefore3",
      title: "Check 3",
      value: getVal("checkBefore3"),
      mandatory: true,
    },
    checkBefore4: {
      key: "checkBefore4",
      title: "Check 4",
      value: getVal("checkBefore4"),
      mandatory: true,
    },
    blurb3: {
      htmlObj: (
        <div>14. What are the 3 Rs when talking about reducing waste?</div>
      ),
    },
    r1: {
      key: "r1",
      title: "R1",
      value: getVal("r1"),
      mandatory: true,
    },
    r2: {
      key: "r2",
      title: "R2",
      value: getVal("r2"),
      mandatory: true,
    },
    r3: {
      key: "r3",
      title: "R3",
      value: getVal("r3"),
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.growUpFarmsOnboarding && appData.growUpFarmsOnboarding.YGU2;
  const redirectBack = () => {
    history.push("/profile/edit/grow-up-farms-onboarding");
  };
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuestionnaire(
      "healthAndSafetyQuestionnaire",
      {
        ...fieldValuesPayload,
      },
      "YGU2"
    );
    redirectBack();
  };
  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Health & Safety Induction Questionnaire"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"growUpFarms"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
HealthAndSafetyQuestionnaire.propTypes = {
  appData: any,
  submitForm: func,
};
const mapDispatchToProps = {
  submitQuestionnaire: submitGrowUpFarmsQuestionnaire,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(HealthAndSafetyQuestionnaire);
